export const newuser = {
    email: '',
    displayName: '',
}



export const access_level_list = [
    {id: 1, label: 'Amministratore'},
    {id: 3, label: 'Gestore evento'},
    {id: 4, label: 'Presenze soggetti evento'},
    {id: 5, label: 'Commissario gara'},
]